import { blipWebsocketHostName, messaginghubWebsocketHostName, blipWebsocketHostNameTenant, aiAgentsSettingsSource, messaginghubWebsocketHostNameTenant, } from 'app.constants';
export class AiAgentsUnattachedController {
    static $inject = ['LoadingService', 'TranslateService', 'AccountService2'];
    constructor(LoadingService, TranslateService, AccountService2) {
        this.LoadingService = LoadingService;
        this.TranslateService = TranslateService;
        this.AccountService2 = AccountService2;
        this.LoadingService.startLoading();
        const setProps = async () => {
            const account = await this.AccountService2.me();
            this.language = this.TranslateService.getCurrentLanguage();
            this.ownerIdentity = '';
            this.webSocketParams = {
                messaginghubWebsocketHostNameTenant,
                messaginghubWebsocketHostName,
                blipWebsocketHostName,
                blipWebsocketHostNameTenant,
            };
            this.LoadingService.stopLoading();
            this.settingsSource = aiAgentsSettingsSource;
            this.user = account.identity;
        };
        setProps();
    }
}
AiAgentsUnattachedController.$inject = ['LoadingService', 'TranslateService', 'AccountService2'];
